import React, {Component} from 'react'
import {Navbar, NavDropdown} from "react-bootstrap";
import SvGraphics from "../../assets/SvGraphics";
import ReactFlagsSelect from 'react-flags-select';
import utils from "../../utils/utils";

/*
import 'react-flags-select/css/react-flags-select.css'
*/
import '../../components_style/NavbarComp.css'
import '../../components_style/rtl_css/NavbarComp.css'
import PropTypes from "prop-types";
import Translate from "../../utils/Translate";
import {authenticationService} from "../../services/AuthenticationService";
import {history} from "../../utils/history";
import Faqs from "./Faqs";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import AlertConfirm from "../modals/Confirm";
import patientApi from "../../services/ApiServices/patientApi";
import LeumitLogo from "../../assets/LeumitLogo.png";
import {appendIchilovQuery} from "../../utils/routeUtils";

class NavbarComponentComposed extends Component {

    constructor(props) {
        super(props);
        this.state = {
            currentUser: null,
            country: Translate.getCurrentCountry(),
            path: false,
            docWidth: document.body.offsetWidth,
            selectedLang: "",
        }
    }

    componentDidMount = () /* */ => {
        const self = this;
        window.addEventListener('resize', function (event) {
            self.setState({docWidth: document.body.offsetWidth})
        }, true);

        let path = history.location.pathname.toLowerCase().includes("pain")
        if (this.props && this.props.currentUser) {
            this.setState({currentUser: this.props.currentUser})
        }
        this.setState({path})
    }

    async onSelectFlag(e) {
        this.setState({selectedLang: e})
        let lang = Translate.getLanguage(e);
        let language = await Translate.setLanguage(lang);
        const {i18n} = this.props;
        await i18n.changeLanguage(language);
        if (Translate.rtl.includes(language)) document.getElementsByTagName("html")[0].setAttribute("dir", "rtl")
        else document.getElementsByTagName("html")[0].setAttribute("dir", "ltr")
    }

    handleLogout = async () /**/ => {
        let {currentUser} = this.state;
        let {t} = this.props
        let isPatient = currentUser ? currentUser.role[0] === "Patient" : false
        let isDoctor = currentUser ? currentUser.role[0] === "Doctor" : false
        let path = history.location.pathname.toLowerCase().includes("pain")
        let leumitUser = currentUser?.profile?.Leumit_clinic

        let programChoosen = localStorage.getItem('ProgrammChoosen');
        let programmRequestID = localStorage.getItem('ProgrammRequestID');
        let checkIfPayed
        if (programmRequestID) {
            checkIfPayed = await patientApi.checkIfPayed(programmRequestID)
            checkIfPayed = checkIfPayed ? checkIfPayed.data : null
        }

        let logoutBool = leumitUser === "T" && isPatient &&
            !(history.location.pathname.toLowerCase().includes("request_sent")) && checkIfPayed && !checkIfPayed.payment && programChoosen === "Y"

        let logoutBoolDoc = leumitUser === "T" && isDoctor &&
            history.location.pathname.toLowerCase().includes("patientrequest")


        let confirm = !logoutBool
        let messageTitle = t('defaults.navbar.sign_out_ques')
        let popUpMessage = t('defaults.navbar.sign_out_mes')

        if (logoutBool || logoutBoolDoc || (isPatient && leumitUser !== "T")) {
            confirm = await AlertConfirm({
                options: {
                    title: messageTitle,
                }
            }, popUpMessage)
        }

        if (confirm) {
            if (logoutBool) {
                let response = await patientApi.deleteLastRequest(programmRequestID)
            }
            authenticationService.logout();
            if (path || leumitUser === "T") {
                history.push('/login_pain')
            } else {
                history.push('/login')
            }
        }


    };

    async backToDashboard() {
        history.push({
            pathname: `/dashboard`,
            state: {
                from: {
                    fromPath: `/dashboard`,
                }
            },
        })
    }

    goToRequests() {
        history.push({
            pathname: appendIchilovQuery('/pain_requests_dashboard'),
            state: {
                from: {
                    fromPath: `/dashboard`,
                }
            },
        })
    }

    render() {
        let {currentUser, docWidth, selectedLang} = this.state;
        let {t} = this.props
        let currentUsername;
        let role
        let isLeumit=false
        let docLeumit = false
        let LastLoginAt;
        if (currentUser) {
            currentUsername = currentUser.profile.First_name + ' ' + currentUser.profile.Last_name
            role = currentUser.role[0] !== "Patient"
            isLeumit = currentUser.profile['Insuring_factor'] === "3"
            docLeumit = currentUser.role[0] === "Doctor" && currentUser.profile.Leumit_clinic === "T"
            LastLoginAt = currentUser.LastLoginAt

            selectedLang = selectedLang ? selectedLang : Translate.getCurrentCountry(localStorage.getItem('language'))

        }

        return (
            <Navbar className={'sade-navbar container'} variant={"dark"}>
                {/*<Navbar.Brand><SvGraphics svgname={'sade_logo'} width={'190px'}/>
                    </Navbar.Brand>*/}
                <Navbar.Brand>
                    {role && !this.state.path ?
                        <SvGraphics svgname={'asaya_logo'} width={'130px'} style={{cursor: 'pointer'}}
                                    onClick={this.backToDashboard}/> : role &&
                        <SvGraphics svgname={'painClinicLogo'} width={'130px'}
                                    style={{cursor: 'pointer', marginRight: "-2.3rem"}}
                                    onClick={this.backToDashboard}/>}
                    {!role && !this.state.path ?

                        <SvGraphics svgname={'asaya_logo'} width={'130px'} style={{cursor: 'pointer'}}/>
                        :
                        !role && isLeumit ? <>
                            <SvGraphics svgname={'painClinicLogo'} width={'230px'}
                                        style={{
                                            cursor: 'pointer',
                                            marginRight: "-2.3rem"
                                        }}
                            />
                            <img src={LeumitLogo} style={{margin:'0px 20px'}} width={'150px'} alt={""}/>

                        </>:
                            !role &&
                                <SvGraphics svgname={'painClinicLogo'} width={'230px'}
                                            style={{
                                                cursor: 'pointer',
                                                marginRight: "-2.3rem"
                                            }}
                                />}

                </Navbar.Brand>
                {role && <Navbar.Collapse className={"justify-content-left-label-blocks"}>
                    <div className={"justify-content-left-label-block"}>
                        <label className={"justify-content-left-label"}
                               onClick={this.backToDashboard}>{t('patient_boarding.Dashboard')}</label>
                    </div>
                    <div className={"justify-content-left-space"}/>

                    {docLeumit && <div className={"justify-content-left-label-block"}>
                        <label className={"justify-content-left-label"}
                               onClick={() => this.goToRequests()}>{t('hcpLeumitPatientRequests.request')}</label>
                    </div>}
                    {docLeumit && <div className={"justify-content-left-space"}/>}
                    <div className={"justify-content-left-label-block"}>
                        <a
                            className={"justify-content-left-label"} href={"https://www.sade.group/resources/"}
                            target="_blank">{t('patient_boarding.Knowledge_Center')}</a>
                    </div>
                    {/*
                    <div className={"justify-content-left-space"}/>
*/}
                    {/*
                    <div className={"justify-content-left-label-block"}>
                        <label className={"justify-content-left-label"}>{t('patient_boarding.Analytics')}</label>
                    </div>*/}

                </Navbar.Collapse>}
                <Navbar.Collapse className={"justify-content-end"}>

                    {role && <div className={'sade-left-navbar-search-input'}>
                        <input className={"navbar-search-input"} placeholder={"Search ID or name"} type="text"
                               name="search"
                               id={"search"}/>
                        <SvGraphics className={"input-pic"} svgname={'search'}
                                    style={{width: '20px', height: '20px'}}/>
                    </div>}

                    {/*        <div className={'sade-left-navbar'}>
                            <div className={'sade-left-navbar-content'}><SvGraphics svgname={'setting-gear'} width={'20px'} height={'20px'}/></div>
                            <div className={'sade-left-navbar-content'}><Faqs/></div>
                        </div>
                        */}

                    <div className={'sade-right-navbar'}>

                        <ReactFlagsSelect selectButtonClassName={'language-select-button'}
                                          className={'sade-right-navbar-content'}
                                          placeholder={t('patient_boarding.choose_language')}
                                          defaultCountry={Translate.getCurrentCountry()}
                                          countries={Translate.getCountries()} showSelectedLabel={true}
                                          showOptionLabel={true} selectedSize={14}
                                          selected={selectedLang}
                                          onSelect={e => this.onSelectFlag(e)}
                                          customLabels={{
                                              "US": "EN",
                                              "IL": "עב",
                                          }}
                        />
                    </div>

                    <div className={'sade-middle-navbar'}>
                        <NavDropdown title={docWidth > 665 ?
                            <div className={'sade-middle-navbar-dropdown-title'}>
                                <div className={'sade-middle-navbar-dropdown-title-content'}>
                                    <SvGraphics className={'sade-navbar-singedin-user'} svgname={'person'}
                                                width={'20px'} height={'20px'}/>
                                    <label
                                        className={'sade-navbar-singedin-user'}>{`${t('defaults.navbar.goodMorning')} ${currentUsername}`}</label>
                                </div>
                            </div>
                            :
                            <SvGraphics className={'sade-navbar-singedin-user'} svgname={'person'}
                                        width={'20px'} height={'20px'}/>
                        } id="basic-nav-dropdown">
                            <NavDropdown.Item className={'info-item2'}>
                                <div>
                                    <div style={{display: 'flex'}}>
                                        <SvGraphics style={{marginTop: '10px'}} svgname={'clockIcon'}
                                                    width={'14px'} height={'13px'}/>
                                        <div className={'last-log-in-time'}>{t('defaults.navbar.LastLoginAt')}</div>
                                    </div>
                                    <div style={{display: 'flex', padding: '0 18px'}}>
                                        <div className={'last-log-in-time'}
                                             style={{fontWeight: '600'}}>{utils.format24(new Date(LastLoginAt))} |
                                        </div>
                                        <div className={'last-log-in-time'}
                                             style={{fontWeight: '600'}}>{utils.getDateFormatWithYear(new Date(LastLoginAt), true)}</div>
                                    </div>
                                </div>
                            </NavDropdown.Item>

                            <NavDropdown.Item className={'info-item'} onClick={this.handleLogout.bind(this)}>
                                <div style={{display: 'flex'}}>
                                    <SvGraphics style={{marginTop: '10px'}} svgname={'logoutIcon'}
                                                width={'13px'} height={'12px'}/>
                                    <div className={'last-log-in-time'}
                                         style={{color: '#005f7f'}}>{t('defaults.navbar.logout')}</div>


                                </div>
                            </NavDropdown.Item>

                        </NavDropdown>
                    </div>

                    {/*
                        <Navbar.Brand href="https://sade-asaya.com/"><SvGraphics svgname={'asaya_logo'} width={'130px'}/></Navbar.Brand>
*/}
                </Navbar.Collapse>
            </Navbar>
        )
    }
}


let NavbarComponent = compose(
    withTranslation()
)(NavbarComponentComposed)

NavbarComponent.propTypes = {
    currentUser: PropTypes.object
};

export default NavbarComponent;
